//import '../ClientValidation/dbh_validation';
//import { dbh_validation, dbhValidatorSettings } from '../ClientValidation/dbh_validation';
import { dbh_custom_validation } from '../ClientValidation/dbh_custom_validation';
import { each } from 'jquery';
import { dbh_helper } from '../src/dbh_helper';
import { dbh_ajax } from '../src/dbh_ajax';

var AnredeSpeicher = '';
var NameSpeicher = '';
var VornameSpeicher = '';
var StrasseSpeicher = '';
var PlzSpeicher = '';
var OrtSpeicher = '';
var LandSpeicher = '';
var TelefonSpeicher = '';
var EmailSpeicher = '';
var isWohngruppeOhneBetreuerInnen : boolean = false;

$(document).ready(function () {
    if ($("#belegungAnlegenForm").length === 0) {
        return;
    }

    $("#belegungAnlegenForm").keydown(function (event) {
        /*Das Formular darf bei Enter nicht submitten, soll in einer Textarea aber in eine neue Zeile springen*/
        if ((event.keyCode == 13) && ($(event.target)[0] != $("textarea")[0])) {
            event.preventDefault();
            return false;
        }
    });

    $('#FK_Pflegesatzgruppen').on('change', function () {
        isWohngruppeOhneBetreuerInnen = $(this).find('option:selected').attr('data-isWohngruppeOhneBetreuerInnen') == "True" ? true : false;
        var isWohngruppe = $(this).find('option:selected').attr('data-isWohngruppe');
        var isKontingent = $(this).find('option:selected').attr('data-isKontingent');
        var hasMonatsstunden = $(this).find('option:selected').attr('data-hasMonatsstunden');
        var hasMonatlicheFallpauschale = $(this).find('option:selected').attr('data-hasMonatlicheFallpauschale');

        if (isWohngruppe.toLowerCase() == "true") {
            $('#plhWohnungen').fadeIn();
        }
        else {
            $('#plhWohnungen').fadeOut();
        }
        if (isKontingent.toLowerCase() == "true") {
            $('.plhKontingent').fadeIn();
        }
        else {
            $('.plhKontingent').fadeOut();
        }
        if (hasMonatsstunden.toLowerCase() == "true") {
            $('#Monatsstunden').prop('checked', true);
        }
        else {
            $('#Monatsstunden').prop('checked', false);
        }
        if (hasMonatlicheFallpauschale.toLowerCase() == "true") {
            $('#MonatlicheFallpauschale1').show();
            $('#MonatlicheFallpauschale2').show();
        }
        else {
            $('#MonatlicheFallpauschale1').hide();
            $('#MonatlicheFallpauschale2').hide();
        }
    });

    $('#FK_Pflegesatzgruppen, #WochenStunden, #KontingentVon, #KontingentBis').on('change', function () {
        berechneKoordinatorStunden();
    });

    $("#StundenString").on('change', function () {
        if ($('#FK_Pflegesatzgruppen').val()) {
            berechneKoordinatorStunden();
        }
    })

    $('#Name, #Vorname, #Geburtsdatum').on('change', function () {
        if ($('#Name').val() != "" && $('#Vorname').val() != "" && $('#Geburtsdatum').val() != "" && parseInt($('#Geburtsdatum').val().toString().substr(0, 4)) > 1990) {
            var form = dbh_helper.findNearestForm($('#Vorname'));

            new dbh_ajax().sendPostRequest({
                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                actionName: "BelegungAnlegenCheckBetreuungSchonVorhanden",
                controllerName: "Belegungen",
                parameter: dbh_helper.getParameterStringForForm(form),
                callbackSuccess: (ajaxResult: any) => {
                    if (ajaxResult.responseText != "") {
                        $('#popup-placeholder').html(ajaxResult);
                        (window as any).showPopup("PopupAehnlicheBelegungVorhanden");
                    }
                },
                callbackError: (ajaxResult: any) => {
                    console.log(ajaxResult);
                }
            });
        }
    });

    //Umschalten der Seite über die Tabs oben.
    $(document).on('click', '.nr', function () {
        var a = $(this)
        if (!a.hasClass('inactive')) {
            changeView(a.attr('data-page'), true);
        }
    });

    //Weiterschalten über den Button unten rechts
    $(document).on('click', '#buttonNext', function () {
        if (checkData($(this).attr('data-for'))) {
            changeView($(this).attr('data-for'), false);
        }
    });

    //Zurückschalten über den Button unten links
    $(document).on('click', '#buttonBack', function () {
        changeView($(this).attr('data-for'), true);
    });

    //Anzeigen der Ansprechpartner nach Änderung des Amtes
    $('.dbh_amt').change(function () {
        var id = $(this)
        //console.log(id.val())
        $(id.attr('data-for')).prop('selectedIndex', 0);

        $(id.attr('data-for')).children().each(function (i, item) {            
            item.hidden = true;
            if (item.getAttribute('data-fkja') == id.val()) {
                item.hidden = false;
            }
        });
    });

    //hervorheben des Fensters zum Ausblenden beim Klick auf eine Kachel
    $(document).on('click', '.dbh_infoBox', function () {
        const popup = $($(this).attr('data-for'));
        popup.show();
        popup.find(".deleteButton").css("display", "flex");

        $('#greyBox').css('z-index', 22);
        loadAngehoerige($(this).attr('data-for'));

        switch ($(this).attr('data-for')) {
            case '#dbh_mutter':
                var test = 'Mutter'
                break;
            case '#dbh_vater':
                var test = 'Vater'
                break;
            case '#dbh_kind_0':
                var test = 'Geschwister_0_'
                break;
            case '#dbh_kind_1':
                var test = 'Geschwister_1_'
                break;
            case '#dbh_kind_2':
                var test = 'Geschwister_2_'
                break;
            case '#dbh_kind_3':
                var test = 'Geschwister_3_'
                break;
            case '#dbh_kind_4':
                var test = 'Geschwister_4_'
                break;
            case '#dbh_kind_5':
                var test = 'Geschwister_5_'
                break;
            case '#dbh_kind_6':
                var test = 'Geschwister_6_'
                break;
            case '#dbh_kind_7':
                var test = 'Geschwister_7_'
                break;
            case '#dbh_kind_8':
                var test = 'Geschwister_8_'
                break;
            case '#dbh_kind_9':
                var test = 'Geschwister_9_'
                break;
        }

        NameSpeicher = $(`#${test}_Name`).val().toString();
        VornameSpeicher = $(`#${test}_Vorname`).val().toString();
        StrasseSpeicher = $(`#${test}_Strasse`).val().toString();
        PlzSpeicher = $(`#${test}_Plz`).val().toString();
        OrtSpeicher = $(`#${test}_Ort`).val().toString();
        LandSpeicher = $(`#${test}_Land`).val().toString();
        AnredeSpeicher = $(`#${test}_FK_Anreden`).val().toString();
        TelefonSpeicher = $(`#${test}_Telefon`).val().toString();
        EmailSpeicher = $(`#${test}_Email`).val().toString();

    });

    $(document).on('click', '.dbh_angehöriger', function () {
        $(this).parent().parent().parent().parent().children('.dbh_Hinweis').show();

        var prefix = "";
        switch ($(this).attr('data-from')) {
            case '#dbh_mutter':
                prefix = 'Mutter';
                break;
            case '#dbh_vater':
                prefix = 'Vater';
                break;
            case '#dbh_kind_0':
                prefix = 'Geschwister_0_';
                break;
            case '#dbh_kind_1':
                prefix = 'Geschwister_1_';
                break;
            case '#dbh_kind_2':
                prefix = 'Geschwister_2_';
                break;
            case '#dbh_kind_3':
                prefix = 'Geschwister_3_';
                break;
            case '#dbh_kind_4':
                prefix = 'Geschwister_4_';
                break;
            case '#dbh_kind_5':
                prefix = 'Geschwister_5_';
                break;
            case '#dbh_kind_6':
                prefix = 'Geschwister_6_';
                break;
            case '#dbh_kind_7':
                prefix = 'Geschwister_7_';
                break;
            case '#dbh_kind_8':
                prefix = 'Geschwister_8_';
                break;
            case '#dbh_kind_9':
                prefix = 'Geschwister_9_';
                break;
            default:
                break;
        }

        $.ajax({
            type: 'POST',
            url: '/belegungen/AngehoerigenAbfragen',
            dataType: 'json',
            data: { 'Id': $(this).attr('data-for') },
            success: function (data) {
                $(`#${prefix}_Name`).val(data.name);
                $(`#${prefix}_Vorname`).val(data.vorname);
                $(`#${prefix}_Strasse`).val(data.strasse);
                $(`#${prefix}_Plz`).val(data.plz);
                $(`#${prefix}_Ort`).val(data.ort);
                $(`#${prefix}_Land`).val(data.land).change();
                $(`#${prefix}_FK_Anreden`).val(data.fK_Anreden).change();
                $(`#${prefix}_Telefon`).val(data.telefon);
                $(`#${prefix}_Email`).val(data.eMail);
            },
            error: function (response) {
                console.log(response);
            }
        });
    });

    //hervorheben des Fensters zum Ausblenden beim Klick auf eine Kachel
    $(document).on('click', '.dbh_infoBoxNeu', function () {
        const popup = $($(this).attr('data-for'));
        popup.show();
        popup.find(".deleteButton").css("display", "none");

        $('#greyBox').css('z-index', 22);
        loadAngehoerige($(this).attr('data-for'));

        NameSpeicher = '';
        VornameSpeicher = '';
        StrasseSpeicher = '';
        PlzSpeicher = '';
        OrtSpeicher = '';
        LandSpeicher = 'DE';
        AnredeSpeicher = '';
        TelefonSpeicher = '';
        EmailSpeicher = '';
    });

    //Ausblenden des formulars beim Klick auf Abbrechen der eingegebenen Daten
    $(document).on('click', '.cancelButton', function () {
        $(this).parents(".dbh_popup").hide();
        //$(this).parent().parent().hide();
        $('#greyBox').css('z-index', 20);

        switch ($(this).attr('data-for')) {
            case '#dbh_mutter':
                var test = 'Mutter'
                break;
            case '#dbh_vater':
                var test = 'Vater'
                break;
            case '#dbh_kind_0':
                var test = 'Geschwister_0_'
                break;
            case '#dbh_kind_1':
                var test = 'Geschwister_1_'
                break;
            case '#dbh_kind_2':
                var test = 'Geschwister_2_'
                break;
            case '#dbh_kind_3':
                var test = 'Geschwister_3_'
                break;
            case '#dbh_kind_4':
                var test = 'Geschwister_4_'
                break;
            case '#dbh_kind_5':
                var test = 'Geschwister_5_'
                break;
            case '#dbh_kind_6':
                var test = 'Geschwister_6_'
                break;
            case '#dbh_kind_7':
                var test = 'Geschwister_7_'
                break;
            case '#dbh_kind_8':
                var test = 'Geschwister_8_'
                break;
            case '#dbh_kind_9':
                var test = 'Geschwister_9_'
                break;
        }

        $(`#${test}_Name`).val(NameSpeicher);
        $(`#${test}_Vorname`).val(VornameSpeicher);
        $(`#${test}_Strasse`).val(StrasseSpeicher);
        $(`#${test}_Plz`).val(PlzSpeicher);
        $(`#${test}_Ort`).val(OrtSpeicher);
        $(`#${test}_Land`).val(LandSpeicher);
        $(`#${test}_FK_Anreden`).val(AnredeSpeicher);
        $(`#${test}_Telefon`).val(TelefonSpeicher);
        $(`#${test}_Email`).val(EmailSpeicher);

        let stepIndex: bigint = BigInt($("form").find("[data-dbh-activeformstepindex]").attr("data-dbh-activeformstepindex"));
        setFormStepIndex(stepIndex);
    });

    //Ausblenden des formulars beim Klick auf Abbrechen + Löschen der eingegebenen Daten
    $(document).on('click', '.deleteButton', function () {
        const popup = $(this).parents(".dbh_popup");
        popup.hide();
        //$(this).parent().parent().hide();
        $('#greyBox').css('z-index', 20);

        const rows = popup.find('.dbh_layoutParent').find('.dbh_form').find('.rows');
        rows.find('input').val('');
        rows.find('.anrede').val('').change();
        rows.find('.land').val(`DE`).change();
        deleteData($(this).attr('data-for'));
    });

    //Speichern der eingegeben Daten für einen Angehörigen
    $(document).on('click', '.saveButton', function () {
        var data = $(this).attr('data-for');
        let isValid: boolean;
        switch (data) {
            case 'mutter':
                isValid = checkData(data);
                if (isValid) {
                    changeData('#mutterBox', 'Mutter', '#Mutter_Name', '#Mutter_Vorname', '#Mutter_Strasse', '#Mutter_Plz', '#Mutter_Ort');
                    $('#Mutter_Angelegt').prop('checked', true);
                }
                else {
                    $('#Mutter_Angelegt').prop('checked', false);
                }
                break;
            case 'vater':
                isValid = checkData(data);
                if (isValid) {
                    changeData('#vaterBox', 'Vater', '#Vater_Name', '#Vater_Vorname', '#Vater_Strasse', '#Vater_Plz', '#Vater_Ort');
                    $('#Vater_Angelegt').prop('checked', true)
                }
                else {
                    $('#Vater_Angelegt').prop('checked', false);
                }
                break;
            default:
                isValid = checkData(data);
                if (isValid) {
                    changeData(`#box${data}`, `Angehöriger`, `#Geschwister_${data}__Name`, `#Geschwister_${data}__Vorname`, `#Geschwister_${data}__Strasse`, `#Geschwister_${data}__Plz`, `#Geschwister_${data}__Ort`);
                    $(`#Geschwister_${data}__Angelegt`).prop('checked', true)
                    if (data != '9') {
                        let nextIndex = parseInt(data) + 1;
                        $('#dbh_info').append(`<div data-for="#dbh_kind_${nextIndex}" class="dbh_infoBoxNeu" id="box${nextIndex}"><img src="/Styles/Images/btn_neu_blue.svg"/>Weitere Angehörige hinzufügen</div>`)
                    }
                }
                else {
                    $(`#Geschwister_${data}__Angelegt`).prop('checked', false)
                }
                break;
        }
        if (isValid) {
            $(this).parents(".dbh_popup").hide();
            $('#greyBox').css('z-index', 20);
        }
    });

    //Zweiten Betreuer einblenden
    $(document).on('click', '#betreuer2', function () {
        $('#betreuer2Box').show();
        $('#betreuer2').removeClass('lastRow');
        $('#betreuer2').html('Betreuer Nr. 2');
    });

    setFormStepIndex(BigInt(0));

    let dbhCustomValidation = new dbh_custom_validation();
    dbhCustomValidation.initClientValidators();
});

const isDesktop = () => {
    // Einsatz von vanilla-Javascript, da dieses deutlich schneller ist als die jquery-Variante
    /* Da die Breite der Website (des Browsers) nicht als eindeutiges Anzeichen für die aktuelle
     * Ansichtsform gelten kann (einige Browser rechnen für die Breite der Seite die Scrollbar mit hinein, andere nicht), wird
     * zur Ermittlung, ob es sich um die Desktop-Ansicht handelt, auf die Sichtbarkeit eines Elements bezogen*/
    return window.getComputedStyle(document.getElementById("desktopDetector"), null).display === "block";
}
const isXLDesktop = () => {
    return window.getComputedStyle(document.getElementById("desktopXLDetector"), null).display === "block";
}

function berechneKoordinatorStunden( ) {

    //StundenKoordinator1String
    let isKontingent = $('#FK_Pflegesatzgruppen').find('option:selected').attr('data-isKontingent').toLowerCase() == "true";
    let isMonatsstundenBelegung = $('#FK_Pflegesatzgruppen').find('option:selected').attr('data-hasMonatsstunden').toLowerCase() == "true";
    let strWochenStunden = $('#StundenString').val();
    let wochenStunden = strWochenStunden && strWochenStunden != undefined && strWochenStunden != '' ? parseFloat(strWochenStunden.toString().replace(",", ".")) : 0;
    let kontingentVonRaw = $('#KontingentVon').val().toString();
    let kontingentBisRaw = $('#KontingentBis').val().toString();
    // Datumsfelder können je nach Fokus-Zustand im deutschen (dd.MM.yyyy) oder englischen (yyyy-MM-dd) Format vorliegen.
    // Für den AJAX-Call wird deshalb einheitlich ins englische Format konvertiert.
    let kontingentVon = kontingentVonRaw.indexOf(".") >= 0 ? dbh_helper.GetEnglishDateFormat(kontingentVonRaw) : kontingentVonRaw;
    let kontingentBis = kontingentBisRaw.indexOf(".") >= 0 ? dbh_helper.GetEnglishDateFormat(kontingentBisRaw) : kontingentBisRaw;
    let stundenWertDefault = $('#FK_Pflegesatzgruppen').find('option:selected').attr('data-stundenDefault');

    if (stundenWertDefault && !isNaN(Number(stundenWertDefault.replace(",", "."))) && Number(stundenWertDefault.replace(",", ".")) != 0) {  
      $("#StundenKoordinator1String").val(Number(stundenWertDefault.replace(",", ".")).toFixed(2).replace(".", ","));  
    }
    else {
        new dbh_ajax().sendGetRequest({
            actionName: "CalcKoordinator1Stunden",
            controllerName: "Belegungen",
            parameter: [
                //@ts-ignore
                ["monatsStunden", isMonatsstundenBelegung],
                //@ts-ignore
                ["wochenStunden", wochenStunden],
                ["fk_Pflegesatzgruppen", $('#FK_Pflegesatzgruppen').find('option:selected').val().toString()],
                ["kontingentBis", kontingentBis],
                ["kontingentVon", kontingentVon]
            ],
            callbackSuccess: (ajaxResult: any) => {
                if (ajaxResult.responseText != "") {
                    let stundenWert: number;
                    stundenWert = parseFloat(ajaxResult.responseText.replace(",", "."));
                    if (stundenWert > 0) {
                        $("#StundenKoordinator1String").attr("readonly", "readonly");
                    }
                    else {
                        $("#StundenKoordinator1String").removeAttr("readonly");
                    }
                    $("#StundenKoordinator1String").val(stundenWert.toFixed(2).replace(".", ","));
                }
            },
            callbackError: (ajaxResult: any) => {
                console.log(ajaxResult);
            }
        });
    }
}

//Umschalten der Seite
function changeView(page, bool) {
    $('.nr').removeClass('active');
    let stepIndex: bigint = BigInt(0);
    switch (page) {
        case 'belegung':
            stepIndex = BigInt(1);
            $('#nr2').addClass('active');
            $('#nr2').removeClass('inactive');
            $('#buttonBack').css('display', 'flex');
            $('#buttonBack').attr('data-for', 'jugendlicher');
            $('#buttonNext').attr('data-for', 'amt');
            $('#buttonNext').css('display', 'flex');
            $('#buttonSubmit').css('display', 'none');
            if (bool) {
                $('#nr3').addClass('inactive');
                $('#nr4').addClass('inactive');
                $('#nr5').addClass('inactive');
            }
            if (!bool) {
                var name = $('#Vorname').val() + ' ' + $('#Name').val();
                $('#nr1').children('.row1').html(name);
                var datum = $('#Geburtsdatum').val().toString().split('.');
                $('#nr1').children('.row2').html('Geb.: ' + datum[0] + '.' + datum[1] + '.' + datum[2]);
            }
            $('#dbh_durchschaltbaresFormular').stop().animate({
                left: isDesktop() ? "-" + $("#dbh_jugendlicher").outerWidth() + "px" : "-100vw"
            });
            break;
        case 'amt':
            stepIndex = BigInt(2);

            $('#nr3').addClass('active');
            $('#nr3').removeClass('inactive');
            $('#buttonBack').css('display', 'flex');

            $('#buttonBack').attr('data-for', 'belegung');
            // bei Bergheim werden keine BetreuerInnen eingetragen, daher diesen Tab überspringen
            if (!isWohngruppeOhneBetreuerInnen) {
                $('#buttonNext').attr('data-for', 'betreuer');
            }
            else {
                $('#buttonNext').attr('data-for', 'familie');
            }
            $('#buttonSubmit').css('display', 'none');
            $('#buttonNext').css('display', 'flex');
            if (bool) {
                $('#nr4').addClass('inactive');
                $('#nr5').addClass('inactive');
            }
            if (!bool) {
                const psg = $('#FK_Pflegesatzgruppen :selected').text();
                $('#nr2').children('.row1').html(psg);
                const stunden = $('#StundenString').val();
                $('#nr2').children('.row2').html($('#Monatsstunden').is(':checked') ? `Monatsstunden: ${stunden}` : `Wochenstunden: ${stunden}`);
            }
            $('#dbh_durchschaltbaresFormular').stop().animate({
                left: isDesktop() ? "-" + ($("#dbh_jugendlicher").outerWidth() + $("#dbh_belegung").outerWidth()) + "px" : "-200vw"
            });
            break;
        case 'betreuer':
            stepIndex = BigInt(3);
            $('#nr4').addClass('active');
            $('#nr4').removeClass('inactive');
            $('#buttonBack').css('display', 'flex');
            $('#buttonBack').attr('data-for', 'amt');
            $('#buttonNext').attr('data-for', 'familie');
            $('#buttonSubmit').css('display', 'none');
            $('#buttonNext').css('display', 'flex');
            if (bool) {
                $('#nr5').addClass('inactive');
            }
            if (!bool) {
                const amt = $('#' + $('[name=FK_ZJ_input]').attr('aria-activedescendant')).text();
                    //$('#FK_ZJ :selected').text();
                $('#nr3').children('.row1').html(amt);
                var ansprechpartner = $('#FK_ZJAn :selected').text();
                $('#nr3').children('.row2').html(ansprechpartner);
            }
            $('#dbh_durchschaltbaresFormular').stop().animate({
                left: isDesktop() ? "-" + ($("#dbh_jugendlicher").outerWidth() + $("#dbh_belegung").outerWidth() +
                    $("#dbh_jugendamt").outerWidth()) + "px" : "-300vw"
            });
            break;
        case 'familie':
            stepIndex = BigInt(4);
            $('#nr5').addClass('active');
            $('#nr5').removeClass('inactive');
            $('#buttonBack').css('display', 'flex');
            // bei Bergheim werden keine BetreuerInnen eingetragen, daher diesen Tab überspringen
            if (!isWohngruppeOhneBetreuerInnen) {
                $('#buttonBack').attr('data-for', 'betreuer');
            }
            else {
                $('#buttonBack').attr('data-for', 'amt');
            }
            $('#buttonSubmit').css('display', 'flex');
            $('#buttonNext').css('display', 'none');
            if (!bool && !isWohngruppeOhneBetreuerInnen) {
                var betreuer = $('#' + $('[name=FK_Betreuer1_input]').attr('aria-activedescendant')).text();
                //$('#FK_Betreuer1 :selected').text();
                $('#nr4').children('.row1').html(betreuer);
                var stunden = $('#Stunden1String').val();
                $('#nr4').children('.row2').html(`Stunden: ${stunden}`);
            } else {
                $('#nr4').children('.row1').html("Keine Angabe notwendig");
                $('#nr4').children('.row2').html("");
            }
            $('#dbh_durchschaltbaresFormular').stop().animate({
                left: isDesktop() ? "-" + ($("#dbh_jugendlicher").outerWidth() + $("#dbh_belegung").outerWidth() +
                    $("#dbh_jugendamt").outerWidth() + $("#dbh_betreuer").outerWidth()) + "px" : "-400vw"
            });
            break;
        default:
            stepIndex = BigInt(0);
            $('#nr1').addClass('active');
            $('#nr1').removeClass('inactive');
            $('#buttonBack').css('display', 'none');
            $('#buttonBack').attr('data-for', 'jugendlicher');
            $('#buttonNext').attr('data-for', 'belegung');
            $('#buttonSubmit').css('display', 'none');
            $('#buttonNext').css('display', 'flex');
            if (bool) {
                $('#nr2').addClass('inactive');
                $('#nr3').addClass('inactive');
                $('#nr4').addClass('inactive');
                $('#nr5').addClass('inactive');
            }
            $('#dbh_durchschaltbaresFormular').stop().animate({
                left: "0"
            });
            break;
    }

    setFormStepIndex(stepIndex);
}

function setFormStepIndex(newStepIndex: bigint) {
    const $form = $("form");
    $form.find("#StepIndex").val(newStepIndex.toString());
    $form.find("[data-dbh-activeformstepindex]").attr("data-dbh-activeformstepindex", newStepIndex.toString());
}

function checkData(page: string): boolean {
    let dbhCustomValidation = new dbh_custom_validation();
    let isValid: boolean;
    switch (page) {
        case 'belegung':
            isValid = dbhCustomValidation.validateForm("#dbh_jugendlicher");
            //console.log("step 'jugendlicher' is valid: " + isValid);
            return isValid;
        case 'amt':
            isValid = dbhCustomValidation.validateForm("#dbh_belegung");
            //console.log("step 'belegung' is valid: " + isValid);
            return isValid
        case 'betreuer':
            isValid = dbhCustomValidation.validateForm("#dbh_jugendamt");
            //console.log("step 'amt' is valid: " + isValid);
            return isValid;
        case 'familie':
            isValid = dbhCustomValidation.validateForm("#dbh_betreuer");
            //console.log("step 'betreuer' is valid: " + isValid);
            return isValid;
        case 'mutter':
            isValid = dbhCustomValidation.validateForm("#dbh_mutter");
            //console.log("step 'mutter' is valid: " + isValid);
            return isValid;
        case 'vater':
            isValid = dbhCustomValidation.validateForm("#dbh_vater");
            //console.log("step 'vater' is valid: " + isValid);
            return isValid;
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            isValid = dbhCustomValidation.validateForm("#dbh_kind_" + page);
            //console.log("step 'kind_'" + page + " is valid: " + isValid);
            return isValid;
        default:
            console.log('Unknown page in checkData');
            return false;
    }
}

function loadAngehoerige(page) {
    var nameJugendlicher = $('#Name').val();
    var ortJugendlicher = $('#Ort').val();
    let stepIndex: bigint = BigInt($("form").find("[data-dbh-activeformstepindex]").attr("data-dbh-activeformstepindex"));
    switch (page) {
        case '#dbh_mutter':
            var name = $('#Mutter_Name').val();
            var ort = $('#Mutter_Ort').val();
            var vorname = $('#Mutter_Vorname').val();
            var email = $('#Mutter_Email').val();
            angehoerigeAnfragen(name == '' ? nameJugendlicher : name, ort == '' ? ortJugendlicher : ort, vorname, email, '#dbh_mutter .dbh_layoutParent .dbh_suggestions .dbh_suggestionList', page);
            break;
        case '#dbh_vater':
            var name = $('#Vater_Name').val();
            var ort = $('#Vater_Ort').val();
            var vorname = $('#Vater_Vorname').val();
            var email = $('#Vater_Email').val();
            angehoerigeAnfragen(name == '' ? nameJugendlicher : name, ort == '' ? ortJugendlicher : ort, vorname, email, '#dbh_vater .dbh_layoutParent .dbh_suggestions .dbh_suggestionList', page);
            break;
        case '#dbh_kind_0':
        case '#dbh_kind_1':
        case '#dbh_kind_2':
        case '#dbh_kind_3':
        case '#dbh_kind_4':
        case '#dbh_kind_5':
        case '#dbh_kind_6':
        case '#dbh_kind_7':
        case '#dbh_kind_8':
        case '#dbh_kind_9':
            var name = $(`#Geschwister_${page}__Name`).val();
            var ort = $(`#Geschwister_${page}__Ort`).val();
            var vorname = $(`#Geschwister_${page}__Vorname`).val();
            var email = $(`#Geschwister_${page}__Email`).val();
            angehoerigeAnfragen(name == '' ? nameJugendlicher : name, ort == '' ? ortJugendlicher : ort, vorname, email, `#dbh_${page} .dbh_layoutParent .dbh_suggestions .dbh_suggestionList`, page);
            break;
        default:
            console.log('Fehler');
            break;
    }

    setFormStepIndex(stepIndex);
}

function angehoerigeAnfragen(name, ort, vorname, email, destination, person) {
    $.ajax({
        type: 'POST',
        url: '/belegungen/AngehoerigeAbfragen',
        dataType: 'json',
        data: { 'Nachname': name, 'Ort': ort, 'Vorname': vorname, 'Email': email },
        success: function (data) {

            var html = '';
            $.each(data, function (i, item) {
                html += `<div class="dbh_angehöriger" data-for="${item.pK_Adressen}" data-from="${person}"><span>${item.vorname} ${item.name}</span><span>${item.strasse}, ${item.plz} ${item.ort}</span>`;
                for (let i = 0; i < item.angehörige.length; i++) {
                    html += `<span>${item.angehörige[i]}</span>`
                }
                html += `</div>`;
            });

            if (html == '') {
                $(destination).html('Wir konnten leider keine Vorschläge finden.');
            } else {
                $(destination).html(html);
            }
            $(".loader").hide();
        },
        error: function (response) {
            $(destination).html('Wir konnten leider keine Vorschläge finden.');
            console.log(response);
        }
    });
}

//Ändern der NeuBox in die DetailBox
function changeData(destination, type, name, vorname, strasse, plz, stadt) {
    const Name = $(name).val();
    const Vorname = $(vorname).val();
    const Strasse = $(strasse).val();
    const PLZ = $(plz).val();
    const Stadt = $(stadt).val();
    const data = `<div class="dbh_infoBoxHeader">${type}<img src="/Styles/Images/btn_edit_pencil_blue.svg"/></div><span class="name">${Name}, ${Vorname}</span><span>${Strasse}</span><span>${PLZ} ${Stadt}</span>`
    $(destination).html(data);
    $(destination).removeClass('dbh_infoBoxNeu');
    $(destination).addClass('dbh_infoBox');
}

function deleteData(destination) {
    switch (destination) {
        case '#vaterBox':
            var text = 'Vater';
            break;
        case '#mutterBox':
            var text = 'Mutter'
            break;
        case '#box0':
        case '#box1':
        case '#box2':
        case '#box3':
        case '#box4':
        case '#box5':
        case '#box6':
        case '#box7':
        case '#box8':
        case '#box9':
            var text = 'Weitere Angehörige';
            break;
    }
    $(destination).html(`<img src="/Styles/Images/btn_neu_blue.svg" />${text} hinzufügen`);
    $(destination).removeClass('dbh_infoBox');
    $(destination).addClass('dbh_infoBoxNeu');
}

